module.exports = __webpack_public_path__ + "static/img/12.69e8923.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/12.png
// module id = VUPb
// module chunks = 0